import './BubbleText.css';

import { FC, HTMLAttributes } from 'react';

export const BubbleText: FC<HTMLAttributes<HTMLDivElement>> = props => {
  const { className = '', ...rest } = props;
  return (
    <div {...rest} className={`BubbleText ${className}`}>
      {props.children}
    </div>
  );
};
